import React from "react";
export default function ResultItem({ item, onSelect, }) {
    return (<button type="button" className="w-full text-left flex items-center gap-3 py-1.5" onClick={() => onSelect(item)}>
      {item.img && (<img src={item.img} alt="" className="h-6 w-10 shrink-0 object-contain" onError={(event) => {
                event.currentTarget.style.display = "none";
            }}/>)}
      <div>
        <span className={"font-medium"}>{item.name}</span>
        {item.body_types && (<span className={"text-sm text-[#66676C]"}>
            &nbsp;· {item.body_types}
          </span>)}
      </div>
    </button>);
}
